/* ============================================================
   clientele-enhance.js
   Clientele NYC — Runtime Enhancements
   Theme: Dawn 15.4.1 · Theme ID 186035568824

   - Condition grade badges on product cards
   - Release calendar signal badges (BUY/HOLD/PASS)
   - Kill blank/empty Dawn sections
   - Force background consistency on dynamic loads
   ============================================================ */

(function () {
  'use strict';

  /* --- CONFIG --- */
  /* Stage 1 palette — white-dominant, high contrast */
  var COLORS = {
    buy: '#00D47E',
    hold: '#FFB300',
    pass: '#FF2E5B',
    bg: '#FFFFFF',
    text: '#141414',
    muted: '#6B6B6B',
    border: '#E5E3DD',
    surface: '#F7F6F3'
  };

  /* --- WAIT FOR DOM --- */
  function onReady(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  /* --- KILL EMPTY SECTIONS --- */
  function killEmptySections() {
    var sections = document.querySelectorAll('.shopify-section');
    sections.forEach(function (section) {
      var inner = section.innerHTML.trim();
      /* If section has no visible content or only whitespace/comments */
      if (!inner || inner.length < 20) {
        section.style.display = 'none';
      }
      /* Stage 1: backgrounds are owned by CSS — no runtime bg forcing */
    });
  }

  /* --- CONDITION BADGES ON PRODUCT CARDS --- */
  function injectConditionBadges() {
    var cards = document.querySelectorAll('.card-wrapper, .product-card-wrapper');
    cards.forEach(function (card) {
      /* Skip if badge already injected */
      if (card.querySelector('.clientele-condition-badge')) return;

      /* Look for condition info in metafields or product tags */
      var tagEl = card.querySelector('[class*="tag"], [data-tag], .card__badge .badge');
      if (!tagEl) return;

      var tagText = tagEl.textContent.trim().toUpperCase();
      var conditions = ['DS', 'VNDS', 'EXCELLENT', 'GOOD', 'FAIR'];
      var matched = conditions.find(function (c) {
        return tagText.indexOf(c) !== -1;
      });

      if (matched) {
        var badge = document.createElement('span');
        badge.className = 'clientele-condition-badge';
        badge.textContent = matched;
        badge.style.cssText = [
          'position:absolute',
          'top:8px',
          'left:8px',
          'z-index:10',
          'font-family:"DM Sans",sans-serif',
          'font-size:11px',
          'font-weight:700',
          'letter-spacing:0.1em',
          'text-transform:uppercase',
          'padding:4px 10px',
          'background:' + COLORS.bg,
          'color:' + COLORS.text,
          'border:1px solid ' + COLORS.border
        ].join(';');

        var imgWrapper = card.querySelector('.card__media, .card__inner, .media');
        if (imgWrapper) {
          imgWrapper.style.position = 'relative';
          imgWrapper.appendChild(badge);
        }
      }
    });
  }

  /* --- RELEASE CALENDAR SIGNAL BADGES --- */
  function injectSignalBadges() {
    /* Target release calendar entries */
    var calendarCards = document.querySelectorAll(
      '.release-card, [data-release-card], .calendar-card, ' +
      '.metafield-rich_text_field table tr, .custom-liquid table tr, ' +
      '.page__content table tr, .rte table tr'
    );

    calendarCards.forEach(function (card) {
      if (card.querySelector('.clientele-signal-badge')) return;

      var text = card.textContent.toUpperCase();
      var signal = null;

      if (text.indexOf('BUY') !== -1) signal = 'buy';
      else if (text.indexOf('HOLD') !== -1) signal = 'hold';
      else if (text.indexOf('PASS') !== -1) signal = 'pass';

      if (signal) {
        var badge = document.createElement('span');
        badge.className = 'clientele-signal-badge';
        badge.textContent = signal.toUpperCase();
        badge.setAttribute('data-signal', signal);
        badge.style.cssText = [
          'display:inline-block',
          'font-family:"DM Sans",sans-serif',
          'font-size:11px',
          'font-weight:700',
          'letter-spacing:0.14em',
          'text-transform:uppercase',
          'padding:4px 12px',
          'margin-left:8px',
          'background:' + COLORS[signal],
          'color:' + (signal === 'pass' ? '#FFFFFF' : '#141414'),
          'border-radius:0'
        ].join(';');

        /* Find the last cell or append to card */
        var lastCell = card.querySelector('td:last-child');
        if (lastCell) {
          lastCell.appendChild(badge);
        } else {
          card.appendChild(badge);
        }
      }
    });
  }

  /* --- FORCE BACKGROUND ON ALL ELEMENTS --- */
  /* Stage 1: retired. The white design system is enforced by CSS;
     runtime background repainting caused inline dark overrides (cart bug). */
  function enforceBackground() {}

  /* --- HEADER ACTIVE STATE --- */
  function highlightActiveNav() {
    var path = window.location.pathname;
    var navLinks = document.querySelectorAll('.header__menu-item, header nav a');
    navLinks.forEach(function (link) {
      var href = link.getAttribute('href');
      if (href && path.indexOf(href) === 0 && href !== '/') {
        link.style.color = '#FF3D00';
      }
    });
  }

  /* --- URL FIXES --- */
  /* NOTE: routing + release-calendar rendering is owned by the inline
     'clientele-inline-routing' script in layout/theme.liquid. The duplicate
     renderer that lived here caused a double-render race (duplicate heading,
     "loading" flash, stale colors) and has been removed. Same data, one owner. */
  function handleRouting() {
    var path = window.location.pathname;
    /* Calendar pages: inline script owns the render — skip enhance passes
       so MutationObserver/badge injection doesn't fight the replaced DOM. */
    if (path === '/pages/release-calendar-2026' || path === '/pages/release-calendar') {
      return true;
    }
    return false;
  }

  /* --- FIX 404 BUTTON --- */
  function fix404Button() {
    var btns = document.querySelectorAll('.shopify-section a.button, .shopify-section .btn, a[href="/collections/all"].button');
    btns.forEach(function (btn) {
      var bg = window.getComputedStyle(btn).backgroundColor;
      if (bg === 'rgb(255, 255, 255)' || bg === 'rgb(242, 240, 235)' || bg === 'rgb(245, 245, 245)') {
        btn.style.backgroundColor = '#FF3D00';
        btn.style.color = '#FFFFFF';
        btn.style.border = 'none';
        btn.style.borderRadius = '0';
        btn.style.fontFamily = '"DM Sans", sans-serif';
        btn.style.fontWeight = '700';
        btn.style.letterSpacing = '0.14em';
        btn.style.textTransform = 'uppercase';
      }
    });
  }

  /* --- INIT --- */
  onReady(function () {
    /* Handle routing first — may redirect away */
    if (handleRouting()) return;

    killEmptySections();
    enforceBackground();
    highlightActiveNav();
    injectConditionBadges();
    injectSignalBadges();
    fix404Button();

    /* Re-run on Shopify section load (for dynamic sections) */
    document.addEventListener('shopify:section:load', function () {
      killEmptySections();
      enforceBackground();
      injectConditionBadges();
      injectSignalBadges();
    });

    /* Re-run after AJAX product loads */
    var observer = new MutationObserver(function (mutations) {
      var hasNewCards = mutations.some(function (m) {
        return m.addedNodes.length > 0;
      });
      if (hasNewCards) {
        injectConditionBadges();
        injectSignalBadges();
        enforceBackground();
      }
    });

    var main = document.getElementById('MainContent') || document.querySelector('main');
    if (main) {
      observer.observe(main, { childList: true, subtree: true });
    }
  });
})();
